module.exports = __webpack_public_path__ + "static/media/webhook-payload.7ddc6cf9.png";